import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wind, LayoutDashboard, BookOpen, Flag, LogOut, Sparkles, GraduationCap, LifeBuoy } from "lucide-react";

export default function Shell({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const doLogout = async () => { await logout(); nav("/login"); };

  const NavLink = ({ to, icon: Icon, label, testid }) => {
    const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
    return (
      <Link to={to} data-testid={testid} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all ${active ? "bg-navy text-warm-white" : "text-ink-mid hover:text-navy hover:bg-cream-dark"}`}>
        <Icon size={16} /> {label}
      </Link>
    );
  };

  return (
    <div className="min-h-screen shell-bg">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-warm-white/80 border-b border-edge">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="app-logo">
            <div className="w-9 h-9 rounded-full bg-navy flex items-center justify-center">
              <Wind size={18} className="text-gold" />
            </div>
            <div className="font-display font-bold text-navy text-lg leading-tight">
              Breathe<span className="text-gold">·</span>Thrive
            </div>
          </Link>
          {user && user !== false && (
            <nav className="hidden md:flex items-center gap-1">
              <NavLink to="/dashboard" icon={LayoutDashboard} label="Home" testid="nav-dashboard" />
              <NavLink to="/learn" icon={GraduationCap} label="Learn" testid="nav-learn" />
              <NavLink to="/library" icon={BookOpen} label="Symptoms" testid="nav-library" />
              <NavLink to="/roadblocks" icon={Flag} label="Roadblocks" testid="nav-roadblocks" />
              <NavLink to="/support" icon={LifeBuoy} label="Support" testid="nav-support" />
            </nav>
          )}
          <div className="flex items-center gap-3">
            {user && user !== false && (
              <div className="hidden sm:flex items-center gap-2 text-xs">
                <Sparkles size={14} className="text-gold" />
                <span className="text-ink-mid">${user.donations_given || 0} given</span>
              </div>
            )}
            {user && user !== false && (
              <button onClick={doLogout} data-testid="logout-btn" className="text-ink-mid hover:text-navy p-2 rounded-full hover:bg-cream-dark transition-all">
                <LogOut size={16} />
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
